import { Component, OnInit } from '@angular/core';
import { SyncwithcognosService } from '~config/services/syncwithcognos.service';

@Component({
  selector: 'syncwithcognos',
  templateUrl: './syncwithcognos.component.html',
  styleUrls: ['./syncwithcognos.component.css']
})
export class SyncwithcognosComponent implements OnInit {

  constructor(private service: SyncwithcognosService) {
    this.service.synWithCognos().subscribe(data => {
      console.log("finished");
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/syncwithcognos/syncwithcognos.component.ts